export default __webpack_public_path__ + "static/media/15_photo.7a1b9b8f.jpg";